module.exports = __webpack_public_path__ + "img/logo-stipendiat.f773ee69.svg";